"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorOverlay = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_hooks_1 = require("@newfront-insurance/react-hooks");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../utils");
var error_card_1 = require("./components/error-card");
/**
 * Render an overlay that takes over the page with details about a NextApiError
 */
function ErrorOverlay(props) {
    var error = props.error, title = props.title, body = props.body, _a = props.top, top = _a === void 0 ? 56 : _a;
    (0, react_hooks_1.usePageTitle)((0, utils_1.getErrorPageTitle)(error));
    return (react_1.default.createElement(core_ui_1.Portal, { name: "error" },
        react_1.default.createElement(StyledOverlay, null,
            react_1.default.createElement(core_ui_1.Padding, { top: top },
                react_1.default.createElement(error_card_1.ErrorCard, { title: title || (0, utils_1.getDefaultErrorTitle)(error), body: body || (0, utils_1.getDefaultErrorText)(error), error: error })))));
}
exports.ErrorOverlay = ErrorOverlay;
var StyledOverlay = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.5);\n  z-index: 10;\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.5);\n  z-index: 10;\n"])));
var templateObject_1;
